import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import Pagination from "../common/pagination";
import PeopleDetail from "./peopledetail"
import { Link } from 'react-router-dom';
import { Switch, Route, Routes } from 'react-router-dom';
import SglContext from '../SglContext'

class MyClass extends React.Component {
  componentDidMount() {
    let value = this.context;
    /* perform a side-effect at mount using the value of MyContext */
  }
  componentDidUpdate() {
    let value = this.context;
    /* ... */
  }
  componentWillUnmount() {
    let value = this.context;
    /* ... */
  }
  render() {
    let value = this.context;
    /* render something based on the value of MyContext */
    return (
      <div>{value.current_user && value.current_user.full_name}</div>
    );
  }
}
MyClass.contextType = SglContext;

export {MyClass}

function People(props) {
  const [people, setPeople] = useState([]);
  const [currentShow, setCurrentShow] = useState(
    localStorage.getItem("show_id")
  );
  const [showName, setShowName] = useState("");
  const [sort, setSort] = useState({ sort_on: "lf_name", sort_type: "asc" });
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [paginationElement, setPaginationElement] = useState(null);
  const [term, setTerm] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const Sgl = useContext(SglContext)

  useEffect(() => {
    setCurrentShow(localStorage.getItem("show_id"));
  }, [props.currentShow]); // add props as dependencies

  useEffect(() => {
    setPaginationElement(React.createRef());
  }, []);

  useEffect(() => {
    axios
      .get(Sgl.nestApiUrl + "/people", {
        params: {
          sort_on: sort.sort_on,
          sort_type: sort.sort_type,
          page: page,
          term: term,
          show_id: currentShow,
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        document.title = "People for " + res.data.show_name;
        Sgl.reportToGA( '/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + currentShow + '/people/list/page/' + page );
        Sgl.reportToFB( '/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + currentShow + '/people/list/page/' + page );
        setPeople(res.data.people);
        setCurrentShow(res.data.show_id);
        setShowName(res.data.show_name);
        setTotalRows(res.data.total_people);
        setLoading(false);
      });
  }, [sort, page, term, currentShow]);

  function onSort(column) {
    if (sort.sort_on != column) {
      setSort({ sort_on: column, sort_type: "asc" });
    } else {
      setSort({
        sort_on: column,
        sort_type: sort.sort_type === "desc" ? "asc" : "desc",
      });
    }
    setPage(1);
  }

  function setArrow(column) {
    let className = "direction";
    if (sort.sort_on === column) {
      className += sort.sort_type === "asc" ? " asc" : " desc";
    }
    return className;
  }

  function onSearch(e) {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    e.persist();
    setSearchTimeout(
      setTimeout(() => {
        setTerm(e.target.value);
        setPage(1);
      }, 700)
    );
  }

  function onChangePage(page) {
    setPage(page);
  }

  function onShowChange(show_id) {
    localStorage.setItem("show_id", show_id);
    this.getPeopleData(
      this.state.sort.sort_on,
      this.state.sort.sort_type,
      1,
      this.state.term,
      show_id
    );
  }

  if (loading) {
    return null;
  }

  return (
    <div className="section-to-print">
      <section className="search-area">
        <table>
          <tbody>
            <tr><td><h2 className='sgl-h2'>People for {showName}</h2></td></tr>
            <tr><td><input
              type="text"
              className="input"
              placeholder="Enter Name or USEF No. to search"
              onKeyUp={(e) => onSearch(e)}
            /></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
      <div className="div-responsive">
        <table className="table table-striped table-hover">
          <tbody>
            <tr className="sgl-primary-header">
              <th onClick={() => onSort('lf_name')} >Name <span className={setArrow('lf_name')}></span></th>
              <th style={{ min_width: '30px' }} onClick={() => onSort('usef_no')}>USEF No <span className={setArrow('usef_no')}></span></th>
            </tr>
            {
              people.map((person, index) => {
                return (
                  <tr key={person.people_id} className='sgl-anchor'>
                    <td><Link to={"/people/detail/" + '?pid=' + person.people_id + '&sid=' + currentShow}>{person.lf_name}</Link></td>
                    {/* <td><a href={'/people/detail/' + person.people_id + '/' + currentShow}>{person.lf_name}</a></td> */}
                    <td><Link to={"/people/detail/" + '?pid=' + person.people_id + '&sid=' + currentShow}>{person.usef_no}</Link></td>
                    {/* <PeopleDetail/> */}
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      <Pagination items={totalRows} onChangePage={onChangePage} initialPage={page} ref={paginationElement} />
      <div><span className="link_color"><b>Showing {((page - 1) * 10) + 1} to {(page - 1) * 10 + people.length} of {totalRows} results.</b></span></div>
      <div className='copyright-text'>
        {" "}
        {process.env.REACT_APP_COPYRIGHT_TEXT}
      </div>
    </div>
  )
}
export default People
